var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading', {'loading-dark': _vm.dark, 'loading-small': _vm.small, 'loading-large': _vm.large}]},[_c('img',{attrs:{"src":_vm.siteConfig.data.imagesUrl.replace('REPLACE_ME', _vm.loadingImage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }